import { TWindowSize } from "libs/hooks/src";

import {
  IMAGE_SRCSET_MEDIA_MAP,
  TImageDimensions,
  TImageFitProp,
  TSrcSet,
  TSrcSetMedia,
} from "./Image.config";
import { ImgHTMLAttributes } from "react";

export const isDefaultFit = (fit: TImageFitProp): boolean => fit === "default";

export const getImageOpacityClasses = (loading: ImgHTMLAttributes<HTMLImageElement>["loading"], isVisible: boolean): string => {
  if (loading === "eager" || isVisible) { return "opacity-100"; }
  return "opacity-0";
};

export const getActiveImageDimensions = (
  windowSize: TWindowSize,
  srcSet: TSrcSet | undefined,
  defaults: TImageDimensions,
): TImageDimensions => {
  if (!srcSet) { return defaults; }

  const activeSrcSet = (Object.entries(IMAGE_SRCSET_MEDIA_MAP) as [ TSrcSetMedia, number ][])
    .sort((a, b) => b[1] - a[1])
    .find(([ breakpoint, minWidth ]) => (
      windowSize.width >= minWidth && srcSet[breakpoint]?.width && srcSet[breakpoint]?.height
    ));

  if (!activeSrcSet) { return defaults; }

  const [ activeBreakpoint ] = activeSrcSet;
  const activeImage = srcSet[activeBreakpoint];

  return {
    width: activeImage?.width,
    height: activeImage?.height,
  };
};
